
'use strict';

const $video = $('.bedar-video');
const $playButton = $('.play-btn');
const $videoProgress = $('.video-progress');
const $progressBar = $('.progress-bar');
const $progressBarDot = $('.progress-bar-dot');
const $currentTime = $('.currentTime');
const $videoDuration = $('.video-duration');
const $volumeButton = $('.volume-button');
let isMuted = true;

// Format time as MM:SS or HH:MM:SS
const formatTime = time => {
    let m = Math.floor(time / 60) % 60;
    let s = Math.floor(time % 60);
    let h = Math.floor(time / 3600);
    return (h ? `${h}:` : '') + `${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`;
};

// Update progress bar & time
const updateTimeDisplay = () => {
    let percentage = ($video[0].currentTime / $video[0].duration) * 100;
    $videoProgress.val($video[0].currentTime);
    $progressBar.css('width', `${percentage}%`);
    $progressBarDot.css('left', `calc( ${percentage}% - 6px )`);
    $currentTime.text(formatTime($video[0].currentTime));
};

const togglePlayButton = () => {
    $playButton.find('.pauseIcon').toggleClass('d-none', $video[0].paused);
    $playButton.find('.playIcon').toggleClass('d-none', !$video[0].paused);
};

const toggleVolumeIcon = () => {
    $volumeButton.find('.unmuteIcon').toggleClass('d-none', $video[0].muted);
    $volumeButton.find('.muteIcon').toggleClass('d-none', !$video[0].muted);
};

// Ensure precise seeking
$videoProgress.on('input', function () {
    $video[0].currentTime = parseFloat(this.value);
});

// Ensure accurate click-based seeking
$videoProgress.on('click', function (e) {
    const clickPosition = (e.offsetX / $(this).width()) * $video[0].duration;
    $video[0].currentTime = clickPosition;
});

// Toggle Play/Pause & Restart if ended
$playButton.on('click', () => {
    if ($video[0].ended) $video[0].currentTime = 0;
    if ($video[0].paused) {
        $video[0].play();
    } else {
        $video[0].pause();
    }
    togglePlayButton();
});

// Toggle Mute/Unmute
$volumeButton.on('click', () => {
    isMuted = !isMuted;
    $video.prop('muted', isMuted);
    toggleVolumeIcon();
});

// Events
$video.on('loadedmetadata', () => {
    $videoProgress.prop('max', $video[0].duration);
    $videoDuration.text(formatTime($video[0].duration));
});

$video.on('timeupdate', updateTimeDisplay);
$video.on('ended', togglePlayButton);

/**
 * Returns the appropriate iframe element for the given element based on the screen width.
 * If the screen width is less than 1024, the mobile iframe is returned.
 * Otherwise, the desktop iframe is returned.
 * @param {$} $element - The element that contains the iframes.
 * @returns {$} - The iframe element to use.
 */
function getIframe($element) {
    return window.innerWidth < 1024 ? $element.find('.video-mobile') : $element.find('.video-desktop');
}

/**
 * Updates the iframe's src attribute, replacing the given `from` string with `to` string.
 * @param {$} $iframe - The iframe element to update.
 * @param {string} from - The string to replace.
 * @param {string} to - The string to replace with.
 */
function updateIframeSrc($iframe, from, to) {
    let src = $iframe.attr('src');
    if (src && src.includes(from)) {
        $iframe.attr('src', src.replace(from, to));
    }
}

/**
 * Plays a video element or an iframe containing a video.
 * If a video element is present within the given element, it plays the video.
 * If an iframe is present instead, it updates the iframe's source to enable autoplay.
 * @param {$} $element - The element that contains the video or iframes.
 */
function playVideo($element) {
    let $videoTag = $element.find('video').get(0);
    let $iframe = getIframe($element);

    if ($videoTag) {
        $videoTag.play();
        togglePlayButton();
    } else if ($iframe) {
        updateIframeSrc($iframe, 'autoplay=0', 'autoplay=1');
    }
}

/**
 * Pauses a video or an iframe containing a video.
 * @param {$} $element - The element that contains the video or iframes.
 */
function pauseVideo($element) {
    let $videoTag = $element.find('video').get(0);
    let $iframe = getIframe($element);

    if ($videoTag) {
        $videoTag.pause();
        togglePlayButton();
    } else if ($iframe) {
        updateIframeSrc($iframe, 'autoplay=1', 'autoplay=0');
    }
}

let observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
        let $element = $(entry.target);
        if ($element.length) {
            if (entry.isIntersecting) {
                playVideo($element, true);
            } else if (!entry.isIntersecting) {
                pauseVideo($element, false);
            }
        }
    });
}, { threshold: 0.5 });

$('.video-component').each(function () {
    observer.observe(this);
});
